import React, { FC } from 'react';
import { View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { ContainerStyle } from '@interfaces/base';
import type { DashboardOverallResponse } from '@api/domain/types';

import DashboardSummarySkeleton from './components/DashboardSummarySkeleton';
import { useManageDashboardSummary } from './hooks/useManageDashboardSummary';
import { DASHBOARD_SUMMARY_CARD_CONFIG } from './constants';
import Card from './components/Card';

interface DashboardSummaryProps extends WithColor, ContainerStyle {
  overall: DashboardOverallResponse | null;
  loading: boolean;
  testIDs?: { loss?: string; gain?: string; net?: string };
}

const DashboardSummary: FC<DashboardSummaryProps> = ({ C, overall, loading, containerStyle, testIDs }) => {
  const { lossText, gainText, netText, netColorKey } = useManageDashboardSummary({ overall });

  if (loading && !overall) {
    return (
      <View style={containerStyle}>
        <DashboardSummarySkeleton />
      </View>
    );
  }

  return (
    <View style={[{ gap: scale(DASHBOARD_SUMMARY_CARD_CONFIG.gap) }, containerStyle]}>
      <View style={{ flexDirection: 'row', gap: scale(DASHBOARD_SUMMARY_CARD_CONFIG.gap) }}>
        <Card
          C={C}
          label={i18n.t('Total Loss')}
          valueText={lossText}
          valueColor={C('System/Light/Red')}
          testID={testIDs?.loss}
        />
        <Card
          C={C}
          label={i18n.t('Total Gain')}
          valueText={gainText}
          valueColor={C('System/Light/Green')}
          testID={testIDs?.gain}
        />
      </View>
      <Card
        C={C}
        label={i18n.t('Net')}
        valueText={netText}
        valueColor={C(netColorKey)}
        testID={testIDs?.net}
        fullWidth
      />
    </View>
  );
};

export default ColorWrapper(DashboardSummary);
